<template>
	<div class='add-plot'>

		<div class='flex-container'>
			<div v-if='lpo.inspection_type_id === "4"'>
				<span class='label'>Радиус, м</span>
				<custom-p-select
					v-model='radius'
					:options='circle_r'
					:optionLabel='null'
					:dataKey='null'
				/>
			</div>

			<div>
				<span class='coord-input-lat'>Широта</span>
				<input class='coord-input-lat' v-model='centerPoint.lat' type='number'>
			</div>
				<!-- <span class='label'>Начало</span> -->
			<div>
				
				<span class='coord-input-lon'>Долгота</span>
				<input class='coord-input-lon' v-model='centerPoint.lon' type='number'>

			</div>

			<div v-if='lpo.inspection_type_id === "2"'>
				<span class='label'>Угол наклона</span>
				<custom-p-select
					v-model='radius'
					:options='info_slope_angle'
					:optionLabel='"slope_angle"'
				/>
			</div>

		</div>
		<div class='btn-row'>
			<button @click='close' class='add-btn'>Закрыть</button>
			<button @click='save' class='add-btn'>Сохранить</button>
		</div>


	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'TypeCircleEditPlot',
		props: {
			plot: {
				type: Object,
				default: null,
			}
		},
		data: () => ({
			radius: null,
			centerPoint: { lat: null, lon: null },
		}),
		computed: {
			lpo() {
				return this.$store.state.selectedLpo.lpo;
			},
			circle_r() {
				return this.$store.state.selectedLpo.recount.circleR;
			},

			...mapState({
				info_slope_angle: state => state.catalogs.info_slope_angle
			})
		},
		methods: {
			save() {
				if ((this.radius === null || this.radius === '') && this.lpo.inspection_type_id === '4') {
					console.log('no radius');
					return;
				}

				if (this.centerPoint.lat === null || this.centerPoint.lat === '' ||
						this.centerPoint.lon === null || this.centerPoint.lon === '') {
					console.log('no center point');
					return;
				}

				const temp = {
					lpo: this.lpo,
					plot: this.plot,
					width: this.radius,
					pointList: [ this.centerPoint ]
				};

				this.editPlotCircle(temp).then(res => {
					this.updatePlotList(this.lpo.lpo_id);
					this.close();
				});

			},

			close() {
				this.$emit('close');
			},

			...mapActions('selectedLpo/recount', [
				'addPlot',
				'editPlotCircle',
				'updatePlotList',
				'getCircleR'
			])
		},
		created() {
			// // this.getCircleR();
			// console.log('plot:', this.plot);

			this.centerPoint = {
				lat: this.plot.points.length ? this.plot.points[0].lat : null,
				lon: this.plot.points.length ? this.plot.points[0].lon : null
			};

			if (this.lpo.inspection_type_id === '4') {
				this.getCircleR();
				this.radius = this.plot.radius_width;

			} else if (this.lpo.inspection_type_id === '2') {

				const catalogs = [ 'info_slope_angle' ];
				this.$store.dispatch('loadCatalogs', catalogs).then(res => {

					if (this.plot.slope_angle_id) {

						const finded = this.info_slope_angle.find(item => {
							return this.plot.slope_angle_id === item.id;
						});

						this.radius = finded;
					} else {
						this.radius = null;
					}
				});
			}




			this.radius = this.plot.radius_width;
			
		}
	};
</script>

<style scoped src='@/style/flex.css'></style>

<style scoped>
	.flex-container {
		gap: 20px;
	}

	.add-plot {
		background-color: #eee;
		border: 1px solid black;
		padding: 20px;
		/*width: 350px;*/
		max-width: 700px;
		text-align: left;
	}

	.grid {
		display: grid;
		grid-template-columns: [label] auto [input-lat] 1fr [input-lon] 1fr [turning-btn] auto;
		grid-gap: 4px;
	}

	.turning-points-block {
		grid-column: span 3;
	}

	.btn-row {
		margin-top: 10px;
	}
	.btn-row > button:first-child {
		margin-right: 10px;
	}

	.label {
		grid-column: label;
		grid-row: auto;
	}
	.width-input {
		grid-column: span 2;
	}
	.coord-input-lat {
		grid-column: input-lat;
		grid-row: auto;
	}
	.coord-input-lon {
		grid-column: input-lon;
		grid-row: auto;
	}
	.add-btn {
		grid-column: span 3;
	}
</style>